//© 2025 Kaitlyn Troxell
import { useState, useEffect } from 'react';
import { 
  collection, 
  getDocs, 
  query, 
  orderBy, 
  deleteDoc, 
  doc, 
  updateDoc 
} from 'firebase/firestore';
import { db } from '../firebase';

function useContractors(user) {
  const [contractors, setContractors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContractors = async () => {
      if (!user) return;

      try {
        setLoading(true);
        const contractorsQuery = query(
          collection(db, 'contractors'),
          orderBy('name', 'asc')
        );

        const querySnapshot = await getDocs(contractorsQuery);
        const contractorsList = [];

        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();
          contractorsList.push({
            id: docSnap.id,
            name: data.name,
            trade: data.trade,
            phone: data.phone,
            email: data.email,
            preferred: data.preferred,
            active: data.active,
            rating: data.rating,
          });
        });

        setContractors(contractorsList);
      } catch (err) {
        console.error("Error fetching contractors:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchContractors();
  }, [user]);

  // Delete contractor
  const deleteContractorById = async (id) => {
    try {
      await deleteDoc(doc(db, 'contractors', id));
      setContractors((prev) => prev.filter((c) => c.id !== id));
    } catch (err) {
      console.error("Error deleting contractor:", err);
    }
  };

  // Update contractor
  const updateContractorById = async (id, updatedData) => {
    try {
      await updateDoc(doc(db, 'contractors', id), updatedData);
      setContractors((prev) =>
        prev.map((c) => (c.id === id ? { ...c, ...updatedData } : c))
      );
    } catch (err) {
      console.error("Error updating contractor:", err);
    }
  };

  return { 
    contractors, 
    loading, 
    setContractors, 
    deleteContractorById, 
    updateContractorById 
  };
}

export default useContractors;
